<template>
  <div class="contain">
    <website-config :tableData="countryData"
                    :isOverseas="isOverseas">

    </website-config>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import WebsiteConfig from './WebsiteConfig';

export default {
  name: 'home',
  components: { WebsiteConfig },
  computed: {
    ...mapState([
      'countryData',
    ]),
  },
  data() {
    return {
      isOverseas: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home.vue